import { css } from '@/styled-system/css';

export const fieldSetStyles = css.raw({
  '& > [data-c11n-component="Legend"]': {
    display: 'block',
    marginBlockEnd: 'FieldSet.gap.controls-toLegendArea',
  },

  '& > [data-c11n-component="FormHelp"]': {
    marginBlockStart: 'FieldSet.gap.controls-toHelperArea',
  },

  // Indent labeled controls only if a legend is present.
  // Using base style instead of variant to ensure this works for composed version.
  '& > [data-c11n-component="Legend"] ~ [data-c11n-component="LabeledControl"]': {
    marginInlineStart: 'FieldSet.labeledControlArea.padding.left',
  },

  // Hide redundant 'required' and 'optional' indicators in labeled controls.
  '& > [data-c11n-component="LabeledControl"] > [data-c11n-component="Label"]:after': {
    content: 'none',
  },
});
